import Api from "../api";
export let FormBadgesFilters = /*#__PURE__*/ function (FormBadgesFilters) {
    FormBadgesFilters[FormBadgesFilters["ExpiredForms"] = 0] = "ExpiredForms";
    FormBadgesFilters[FormBadgesFilters["CloseToExpireForms"] = 1] = "CloseToExpireForms";
    return FormBadgesFilters;
}({});
const basePath = "/Form";
export function baseUpdate(params) {
    return Api.post(`${basePath}/Base/update`, params);
}
export async function getAll(params) {
    params.status = Array.isArray(params.status) ? params.status : params.status ? [params.status] : undefined;
    const result = await Api.post(`${basePath}/getAll`, params);
    return result;
}
;
export async function getAdhocs(userLocationId, params) {
    params.adhoc = true;
    params.status = ["Active", "OldVerPub"];
    params.isTemplate = false;
    params.userTopics = true;
    params.locationId = Array.isArray(userLocationId) ? userLocationId : [userLocationId]; //Adhoc form is listed using userLocation
    const r = await getAll(params);
    return r;
}
export async function get(id, languageId) {
    let url = `${basePath}/get?id=${id}`;
    if (languageId) {
        url += `&languageId=${languageId}`;
    }
    const result = await Api.get(url);
    return result;
}
export async function getWorkflowSignals() {
    const url = `${basePath}/getWorkflowSignals`;
    const result = await Api.get(url);
    return result;
}
